// TODO: Move code below to design system /adc/src/util/formatters.js
import moment from 'moment'

// Formatters, Filters for phone numbers
export const phone = {
  // Formats a ten digit phone number: '1234567890' => '(123) 456-7890'
  format: value => {
    const digits = (value + '').replace(/[^\d]/g, '')
    if (digits.length === 10 && digits === '' + parseInt(digits)) {
      return (
        '(' +
        digits.slice(0, 3) +
        ') ' +
        digits.slice(3, 6) +
        '-' +
        digits.slice(6)
      )
    } else {
      return value
    }
  },
}

// Formatters, Filters for generic numbers, type can be percentage / currency or default number type
export const number = {
  isNumber: value => {
    return !isNaN(parseFloat(value))
  },
  format: (value, type) => {
    if (!value) return ''
    else {
      value = '' + value
      value = value.replace(/[^\d.-]/g, '') // Filter out everything but number, decimal, and negative sign characters.
      value = value.replace(/,/g, '') // Remove commas temporarily.
      value = value.split('.')

      value[0] = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') // Add commas.
      value = value.join('.') // Restore decimal values if any.
    }
    switch (type) {
      case 'currencyRounded':
        // truncate decimals (if any)
        if (value.includes('.')) {
          value = value.split('.')
          value = value[0]
        }
        value = `$${value}`
        break
      case 'currency':
        // if number has decimal, format to 2 decimal places
        if (value.includes('.')) {
          value = value.split('.')
          value[1] = parseFloat('.' + value[1])
            .toFixed(2)
            .substring(2)
          value = value.join('.')
        }
        value = `$${value}`
        break
      case 'percentage':
        value = value + '%'
        break
      default:
        break
    }
    return value
  },
  formatRange: values => {
    if (Array.isArray(values)) {
      return values.map(value => {
        const val = parseFloat(value)
        let val2
        if (isNaN(val)) {
          return { val: '', order: '' }
        }
        if (val >= 1000000.0) {
          val2 = (val / 1000000.0).toFixed(1)
          // strip out ".0" if present
          return {
            val:
              val2.substr(-2) === '.0' ? val2.substr(0, val2.length - 2) : val2,
            order: 'M',
          }
        } else if (val >= 1000.0) {
          val2 = (val / 1000.0).toFixed(1)
          return {
            val:
              val2.substr(-2) === '.0' ? val2.substr(0, val2.length - 2) : val2,
            order: 'K',
          }
        } else {
          return { val: val.toFixed(0), order: '' }
        }
      })
    } else {
      return values
    }
  },
}

export const date = {
  format: (value, format, inputFormat) => {
    if (value && moment(value, inputFormat).isValid()) {
      return moment(value, inputFormat).format(format || 'L')
    }
    return value
  },
}

export const url = {
  format: url => {
    if (!url) return ''
    return url.substr(0, 'http'.length) !== 'http' ? 'http://' + url : url
  },
}
